module.exports = __webpack_public_path__ + "img/avalia-login-logo.64b5de3d.png";